var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-tooltip",
    {
      attrs: {
        placement: "right",
        overlayClassName: _vm.tooltipOverlayClass,
        mouseEnterDelay: 0.7,
      },
    },
    [
      _c("template", { slot: "title" }, [
        _vm.useRichTooltip
          ? _c("div", { staticClass: "sft-card" }, [
              _c("div", { staticClass: "sft-card-title-row" }, [
                _vm.titleMaterialIconName
                  ? _c(
                      "span",
                      {
                        staticClass: "sft-card-title-icon material-icons",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v(_vm._s(_vm.titleMaterialIconName))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "sft-card-title" }, [
                  _vm._v(_vm._s(_vm.titleText)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "sft-card-body",
                domProps: { innerHTML: _vm._s(_vm.richDescriptionHtml) },
              }),
            ])
          : _c("span", { staticClass: "sft-simple-title-wrap" }, [
              _vm.titleMaterialIconName
                ? _c(
                    "span",
                    {
                      staticClass: "sft-simple-title-icon material-icons",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_vm._v(_vm._s(_vm.titleMaterialIconName))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "sft-simple-title" }, [
                _vm._v(_vm._s(_vm.titleText)),
              ]),
            ]),
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "sidebar-item-tooltip-wrap" },
        [_vm._t("default")],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }